import { FileIcon } from 'assets/icons/FileIcon'

export const initialAreas = {
  '1': 'attendance',
  '2': 'shifts',
  '3': 'accommodation',
  '4': 'ph-4',
  '5': 'ph-5',
  '6': 'ph-6',
  '7': 'ph-7',
  '8': 'ph-8',
}

export const initialPresentWidgets = ['attendance', 'shifts', 'accommodation', '', '', '', '']

export const hrWidgetsList = [
  {
    width: 1,
    type: 'attendance',
    icon: FileIcon,
    title: 'Attendance',
  },
  {
    width: 1,
    type: 'shifts',
    icon: FileIcon,
    title: 'Shifts',
  },
  {
    width: 1,
    type: 'accommodation',
    icon: FileIcon,
    title: 'Accommodation',
  },
  {
    width: 1,
    type: 'notifications',
    icon: FileIcon,
    title: 'Notifications',
  },
  {
    width: 2,
    type: 'suggestions',
    icon: FileIcon,
    title: 'AI Suggestions',
  },
  {
    width: 2,
    type: 'alerts',
    icon: FileIcon,
    title: 'Alerts & Requests',
  },
]

export interface IWidgetListItem {
  width: number
  type: string
  icon: any
  title: string
  subTitle?: string
  desc?: string
}
